import processPostsListAJAX from '../util/processPostsListAJAX';

export default {
    publicationsAJAX() {
        let $publicationsPaginationLinks = $(
            '#filter-container-publications .pagination a'
        );
        if ($publicationsPaginationLinks.length > 0) {
            $publicationsPaginationLinks.on('click', function (e) {
                e.preventDefault();
                processPostsListAJAX(this.href, 'visc-qf-publications');
            });
        }
    },
    init() {
        // JavaScript to be fired on the publications page
        this.publicationsAJAX();
        $(document).on('visceralPosts:ajaxSuccess', () => {
            this.publicationsAJAX();
        });
    },
    finalize() {
        // JavaScript to be fired on the publications page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/publications.js